"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.environmentNameManager = void 0;
class EnvironmentNameManager {
    constructor() {
        this.envNameRegex = /^[\w\d-_]+$/;
        this.envConfigNameRegex = /^config\.(?<envName>[\w\d-_]+)\.json$/i;
        this.envStateNameRegex = /^state\.(?<envName>[\w\d-_]+)\.json$/i;
        this.schema = "https://aka.ms/teamsfx-env-config-schema";
        this.defaultEnvName = "dev";
        this.localEnvName = "local";
        this.testToolEnvName = "testtool";
        this.playgroundEnvName = "playground";
        this.sandboxEnvName = "sandbox";
    }
    getDefaultEnvName() {
        return this.defaultEnvName;
    }
    getLocalEnvName() {
        return this.localEnvName;
    }
    getTestToolEnvName() {
        return this.testToolEnvName;
    }
    getPlaygroundEnvName() {
        return this.playgroundEnvName;
    }
    getSandboxEnvName() {
        return this.sandboxEnvName;
    }
    getNonRemoteEnvNames() {
        return [this.localEnvName, this.testToolEnvName, this.playgroundEnvName];
    }
    isRemoteEnvironment(env) {
        return this.getNonRemoteEnvNames().indexOf(env) === -1;
    }
}
exports.environmentNameManager = new EnvironmentNameManager();
//# sourceMappingURL=environmentName.js.map